import { render, staticRenderFns } from "./DatasetTaskList.vue?vue&type=template&id=397f46e7&scoped=true"
import script from "./DatasetTaskList.vue?vue&type=script&lang=js"
export * from "./DatasetTaskList.vue?vue&type=script&lang=js"
import style0 from "./DatasetTaskList.vue?vue&type=style&index=0&id=397f46e7&scoped=true&lang=css"
import style1 from "./DatasetTaskList.vue?vue&type=style&index=1&id=397f46e7&lang=scss&scoped=true"
import style2 from "./DatasetTaskList.vue?vue&type=style&index=2&id=397f46e7&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397f46e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('397f46e7')) {
      api.createRecord('397f46e7', component.options)
    } else {
      api.reload('397f46e7', component.options)
    }
    module.hot.accept("./DatasetTaskList.vue?vue&type=template&id=397f46e7&scoped=true", function () {
      api.rerender('397f46e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/task/DatasetTaskList.vue"
export default component.exports